module.exports = __webpack_public_path__ + "static/media/sky-app.bda7e093.png";